module.exports = __webpack_public_path__ + "img/dressCode.f583e026.jpg";